module.exports = __webpack_public_path__ + "img/now_loading.2d0191f6.png";